import React from "react";
import classnames from "classnames";
import styles from "./PreviewTag.module.scss";

interface Props {
  className?: string;
}

function PreviewTag({ className }: Props) {
  return <span className={classnames(styles.tag, className)}>Preview</span>;
}

export default PreviewTag;
